import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, token } = useAuth();

  useEffect(() => {
    console.log('[PrivateRoute] Component mounted/updated');
    console.log('[PrivateRoute] Authentication state:', { isAuthenticated, isLoading });
    console.log('[PrivateRoute] Token exists:', !!token);
    
    // Check localStorage directly
    const localToken = localStorage.getItem('token'); 
    console.log('[PrivateRoute] Token in localStorage:', !!localToken);
    if (localToken) {
      console.log('[PrivateRoute] Token from localStorage (first 15 chars):', localToken.substring(0, 15));
    }
    
    if (!isAuthenticated && !isLoading && localToken) {
      console.warn('[PrivateRoute] MISMATCH: Token exists in localStorage but isAuthenticated is false!');
    }
  }, [isAuthenticated, isLoading, token]);

  if (isLoading) {
    console.log('[PrivateRoute] Still loading, showing spinner');
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  console.log('[PrivateRoute] Done loading, isAuthenticated =', isAuthenticated);
  
  if (isAuthenticated) {
    console.log('[PrivateRoute] User is authenticated, rendering children');
    return <>{children}</>;
  } else {
    console.log('[PrivateRoute] User is NOT authenticated, redirecting to login');
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
